module.exports = __webpack_public_path__ + "img/icon-form-textbox-gray.cc56966a.svg";